import copy from 'copy-text-to-clipboard';
document.addEventListener('DOMContentLoaded', () => {
    const element = document.querySelector('.social-media-share-links');
    if (typeof (element) != 'undefined' && element != null) {
        const copyLinkIcon = document.querySelector('.copy-to-clipboard');
        const successHintElement = document.querySelector('.copy-success-hint')
        const successHintText = copyLinkIcon.getAttribute('data-success-text')
        const shareURL = copyLinkIcon.getAttribute('data-share-url')
        copyLinkIcon.addEventListener('click', () => {
            copy(shareURL)
            successHintElement.innerText = successHintText
            successHintElement.classList.add('show')
            setTimeout(() => {
                successHintElement.classList.remove('show')
            }, 2000)
        })
    }
})
